import { state } from '../lib/state.js';
import { exportExcelReport } from '../services/report-service.js';
import { captureMap } from '../ui/map.js';
import { els } from '../app/dom.js';
import { syncHeaderFields } from '../routes/route-actions.js';
import { setStatus } from '../lib/app-helpers.js';
import { requestRender } from '../app/events.js';

export async function exportCurrentReport() {
  syncHeaderFields();
  if (!state.currentRoute.sections.length) return;
  const button = els.exportReportBtn;
  const previousText = button.textContent;
  button.disabled = true;
  button.textContent = 'Przygotowuję raport…';

  try {
    await exportExcelReport({
      ...state.currentRoute,
      mapScreenshotDataUrl: captureMap() || state.currentRoute.mapScreenshotDataUrl,
    });
    setStatus(els.extensionStatus, 'Raport został przygotowany. Zawiera wyniki i zrzuty kalkulatorów bez dodatkowych dużych map odcinków.', 'ok');
  } catch (error) {
    console.error(error);
    setStatus(els.extensionStatus, `Nie udało się przygotować raportu: ${error.message}`, 'error');
  } finally {
    button.textContent = previousText;
    requestRender();
  }
}

